var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInviteCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110.7 110.7",
    style: {
      enableBackground: "new 0 0 110.7 110.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#545554;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,83c0,1.5-0.1,3-0.1,4.5c0,0.9,0,1.7,0,2.7c-5.7,0-11.4,0-17.1,0c0.7-8.6-2.6-15.2-10.1-19.6 c0.3-0.9,0.7-1.9,0.9-2.8c2.7-9-1.5-18.3-10-22.4c-0.5-0.2-0.6-0.5-0.6-0.9c0.6-4.5,2.9-8.2,6.9-10.6c8-4.8,18.1-1,20.9,7.8 c1.7,5.4,0.5,10.1-3.3,14.3c-0.2,0.2-0.5,0.3-0.7,0.6c1.2,0.3,2.2,0.5,3.3,0.8c5.6,2,8.9,5.9,9.8,11.8c0,0.1,0.1,0.3,0.1,0.5 C90.6,74.2,90.6,78.6,90.6,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,73.1c-3.5-3.4-5.1-7.5-4.5-12.2c0.3-3.5,1.9-6.4,4.4-8.7c5.5-5.1,13.9-5,19.2-0.2 c5.4,4.7,7.2,14.6,0.1,21.3c5.1,0.7,9,3.3,11.4,7.8c1.5,2.9,1.9,6.1,1.4,9.3c-15.2,0-30.3,0-45.5,0c-0.7-8.4,3.7-15.4,12.2-17 C35.7,73.2,36,73.1,36.5,73.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.3,37.6c-1.7,0-3.5,0-5.2,0c-2,0-3.4-1.2-3.8-3c-0.6-2.3,1.2-4.8,3.6-4.9c1.5,0,3.1,0,4.7,0 c0.2,0,0.5,0,0.8,0c0-1.9,0-3.6,0-5.4c0-1.4,0.7-2.6,1.9-3.3c2.7-1.6,5.9,0.2,6.1,3.4c0,1.5,0,3,0,4.4c0,0.2,0,0.5,0,0.8 c1.7,0,3.5,0,5.2,0c0.9,0,1.7,0.2,2.4,0.8c1.4,1,1.9,2.8,1.4,4.4c-0.5,1.6-2,2.7-3.6,2.8c-1.5,0-3,0-4.7,0c-0.2,0-0.5,0-0.8,0 c0,1.9,0,3.5,0,5.2c0,1.9-1.2,3.4-2.9,3.8c-2.4,0.7-4.9-1.2-5-3.6c0-0.9,0-1.7,0-2.7C29.3,39.4,29.3,38.5,29.3,37.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInviteCustomer);
export default __webpack_public_path__ + "static/media/ic_invite_customer.ea18d7a8c7188cc39cd156d15c910d29.svg";
export { ForwardRef as ReactComponent };